import { Reveal, SectionTag, SectionTitle, StatusBadge } from "./shared";
import { TIMELINE } from "../data/site";

export function Timeline() {
  return (
    <section className="relative py-28 lg:py-40 bg-[#0A0A0A]" data-testid="timeline-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>The Development Timeline</SectionTag>
        <SectionTitle className="mb-16">Watch a New Urban Corridor <span className="text-gold-gradient italic">Take Shape.</span></SectionTitle>

        <div className="grid lg:grid-cols-3 gap-6" data-testid="timeline-grid">
          {TIMELINE.map((era, ei) => (
            <Reveal key={era.era} delay={ei * 0.12}>
              <div className="relative border border-[#D4AF37]/14 bg-[#101010] rounded-[2px] p-7 h-full">
                <span className="font-serif-lux text-5xl text-gold-gradient italic">{era.era}</span>
                <div className="gold-hairline my-6" />
                <div className="space-y-7">
                  {era.items.map((item, ii) => (
                    <div key={item.title} className="relative pl-6" data-testid={`timeline-item-${era.era.toLowerCase()}-${ii}`}>
                      <span className="absolute left-0 top-1.5 w-2 h-2 rounded-full border border-[#D4AF37] bg-[#0A0A0A]" />
                      {ii < era.items.length - 1 && <span className="absolute left-[3.5px] top-5 bottom-[-24px] w-px bg-[#D4AF37]/20" />}
                      <div className="flex items-start justify-between gap-3 mb-1.5">
                        <h4 className="font-serif-lux text-lg text-[#F5F5F0] leading-tight">{item.title}</h4>
                        <StatusBadge status={item.status} />
                      </div>
                      <p className="text-[12px] text-[#71717A] leading-relaxed">{item.detail}</p>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
